export default __webpack_public_path__ + "e24f6e555846c8609e0116bb3dd08b14.png";